<!-- 会員情報変更コンポーネント -->
<template>
    <div class="regist">
        <form method="post" ref="changeUserinfoForm" @submit.prevent="submit">
            <input :value="dataCsrf"
                   :name="dataCsrfName"
                   type="hidden">
            <input :value="dataToken"
                   name="token"
                   type="hidden">
            <input v-model="jsonPatchForUserInfo"
                   name="userinfo_patch"
                   type="hidden">

            <user-info-form v-show="!isConfirm"
                            @alert-message="showMessage"
                            @next="next"
                            :step="step"
                            :display-pattern="displayPattern"
                            :is-display-agreement-check="false"
                            :userinfo="userInfoPatch">
                <template v-slot:note>
                    <p>
                        この内容で登録します。<br>
                        よろしければ登録ボタンをクリックしてください。
                    </p>
                </template>
            </user-info-form>
            <user-info-confirm v-if="isConfirm"
                               @back="back"
                               :step="step"
                               :display-pattern="displayPattern"
                               :userinfo="userInfoPatch"></user-info-confirm>
        </form>
    </div>
</template>

<script>
import jsonpatch from 'fast-json-patch'
import { mixinJleague, mixinUserInfoProperties, EnumClientDisplayPattern } from '../mixin/utility'
import UserInfoForm from './UserInfo/UserInfoForm'
import UserInfoConfirm from './UserInfo/UserInfoConfirm'

export default {
    name: 'UserInfo',
    components: {
        'user-info-form': UserInfoForm,
        'user-info-confirm': UserInfoConfirm,
    },
    mixins: [mixinJleague, mixinUserInfoProperties],
    data() {
        return {
            userInfoPatch: {},
            jsonPatchObserver: {},
            jsonPatchForUserInfo: '',
            step: 'INPUT'
        }
    },
    props: {
        dataCsrf: {
            type: String,
            required: true
        },
        dataCsrfName: {
            type: String,
            required: true
        },
        dataToken: {
            type: String,
            required: true
        },
        userinfo: {
            type: Object,
            required: true
        },
    },
    created: function(){
        this.userInfoPatch = Object.assign({}, this.userinfo);
        this.jsonPatchObserver = jsonpatch.observe(this.userInfoPatch);

        // 不足している userinfo プロパティーをセットする
        this.userInfoPatch = this.assignDeficientProperties(this.userInfoPatch);
    },
    computed: {
        displayPattern: function(){
            const client = this.jleagueClient;
            return (Object.keys(client).length !== 0 && client.hasOwnProperty('display_pattern'))?
                client.display_pattern:
                EnumClientDisplayPattern.Full;
        },
        isConfirm: function(){
            return this.step === 'CONFIRM';
        }
    },
    methods: {
        back: function(step){
            switch (step) {
                case 'CONFIRM':
                    this.step = 'INPUT';
                    break;
                default:
                    this.step = 'INPUT';
                    break;
            }
        },
        next: function(step, userInfoPatch){
            this.userInfoPatch = userInfoPatch;
            switch (step) {
                case 'INPUT':
                    this.step = 'CONFIRM';
                    break;
                default:
                    this.step = 'INPUT';
                    break;
            }
        },
        showMessage: function(message){
            this.$emit('alert-message', message, EnumAlertType.Error);
        },
        emptyStringToNull: function(value){
            return (value !== '')? value: null;
        },
        generateJsonPatch: function(){
            const self = this;
            return new Promise(function(resolve){
                // 空文字列のときは null に変換する
                Object.keys(self.userInfoPatch).forEach(function(key){
                    self.userInfoPatch[key] = self.emptyStringToNull(self.userInfoPatch[key]);
                });
                let jsonPatchData = jsonpatch.generate(self.jsonPatchObserver)
                jsonPatchData.push(
                  { "op": "add", "path": "/sfdc_necessary_api_call_mode", "value": "1" },
                  { "op": "add", "path": "/sfdc_sync_member", "value": "1" }
                )
                self.jsonPatchForUserInfo = JSON.stringify(jsonPatchData);
                resolve(self.jsonPatchForUserInfo);
            });
        },
        submit: async function(){
            const form = this.$refs.changeUserinfoForm;

            await this.generateJsonPatch();
            form.submit();
        }
    }
}
</script>
